import {
  ApiGetMyWishlistsRequestedAction,
  apiGetMyWishlistsFailed,
  apiGetMyWishlistsSucceeded
} from '@spa/lib/store/api/wishlists/getMyWishlistsApi';
import { call, put } from 'typed-redux-saga';
import { WishlistError } from '@spa/components/wishlist/wishlistTypes';
import getMyWishlistsAction from '@spa/lib/actions/wishlists/getMyWishlistsAction';
import logger from '@spa/lib/logger';

function* getMyWishlistsApiSaga({
  payload: { actionId: requestedActionId, parentActionId }
}: ApiGetMyWishlistsRequestedAction): Generator {
  try {
    const result = yield* call(getMyWishlistsAction, 'getMyWishlistsAction');

    yield* put(apiGetMyWishlistsSucceeded({ parentActionId, requestedActionId, result }));
  } catch (e) {
    logger.error(e, 'Error fetching my wishlists');

    yield* put(
      apiGetMyWishlistsFailed({
        error: WishlistError.UNKNOWN_ERROR,
        parentActionId,
        requestedActionId
      })
    );
  }
}

export default getMyWishlistsApiSaga;
